export const isArrivedOrder = (orderStatus?: string | null): boolean => {
  return orderStatus === "REVIEWED"
}
